import { render, staticRenderFns } from "./TiposFrete.vue?vue&type=template&id=249971ba"
import script from "./TiposFrete.vue?vue&type=script&lang=js"
export * from "./TiposFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports